import Vue from 'Vue';
import {
  helpers
} from 'vuelidate/lib/validators';

/* global _as_rest */
/* eslint camelcase: 0 */

const luhn = num => {
  num = String(num).replace(/\D+/g, '').split('').reverse();

  if (!num.length) {
    return false;
  }

  let total = 0;

  for (let i = 0; i < num.length; i++) {
    num[i] = parseInt(num[i], 10);
    // eslint-disable-next-line yoda
    total += i % 2 ? 2 * num[i] - (num[i] > 4 ? 9 : 0) : num[i];
  }

  // eslint-disable-next-line yoda
  return (total % 10) === 0;
};

export const validators = {
  credit_card_number: value => !helpers.req(value) || (16 === value.length && luhn(value)),
  expiry_date: value => {
    if (!helpers.req(value)) {
      return true;
    }

    let minimum_month = new Date().getMonth() + 1;
    let minimum_year = new Date().getFullYear().toString().substr(-2);

    // eslint-disable-next-line yoda
    if (minimum_month < 10) {
      minimum_month = '0' + minimum_month.toString();
    }

    let minimum = `${minimum_year}/${minimum_month}`;

    return 5 === value.length && value.replace(/^([0-9]{2})\/([0-9]{2})$/g, '$2/$1') >= minimum;
  },
  regex: pattern => value => !helpers.req(value) || pattern.test(value)
};

export const removeAllVuePreloadHiddenClasses = selector => {
  const parent = document.querySelector(selector);

  if (null === parent) {
    return;
  }

  const className = 'vue-preload-hidden';
  const elements = parent.querySelectorAll(`.${className}`);

  for (let i = 0; i < elements.length; ++i) {
    elements[i].classList.remove(className);
  }
};

export const removeAllVuePostloadHiddenElements = selector => {
  const parent = document.querySelector(selector);

  if (null === parent) {
    return;
  }

  const className = 'vue-postload-hidden';
  const elements = parent.querySelectorAll(`.${className}`);

  for (let i = 0; i < elements.length; ++i) {
    elements[i].parentNode.removeChild(elements[i]);
  }
};

window.$asEventBus = window.$asEventBus || new Vue();
export const $eventBus = window.$asEventBus;
